module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-flyer-768x591.1d587243.jpg";